import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading, mustChangePassword } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (mustChangePassword) return <Navigate to="/staff/set-password" replace />;
  // UtilityAdmin has functional-peer access to Admin pages (Feb 2026 rollout,
  // option (a) in the sidebar-privilege change). is_dev_admin is remapped to
  // 'admin' server-side so it lands here too.
  if (user.role !== "admin" && user.role !== "super_admin" && user.role !== "utility_admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
